import IframeWidget from '../components/widgets/IframeWidget.vue'
import { configuration } from '@dpgradio/creative'
import { ref } from 'vue'

const brandWidgetConfig = {
  qmusic_be: [
    {
      id: 'forbidden_word_counter',
      name: 'forbidden_word_counter',
      widget: IframeWidget,
      props: {
        url: 'https://verboden-woord.qmusic.be/counter?skip_privacy=true',
        height: '200px',
        reloadInterval: 30,
      },
      startDate: '2026-02-27T06:00:00Z',
      endDate: '2026-03-06T23:00:00Z',
    },
    {
      id: 'forbidden_word_detections',
      name: 'forbidden_word_detections',
      widget: IframeWidget,
      props: {
        url: 'https://forbidden-word-counter.pages.dev/?apiKey=752ceb1cc13b35ac&campaign=verboden_woord_be&showAutodetect',
        height: '150px',
      },
      startDate: '2026-02-27T06:00:00Z',
      endDate: '2026-03-06T23:00:00Z',
    },
  ],
}

export function useWidgets() {
  const brand = configuration.stationId
  const widgets = brandWidgetConfig[brand] || []
  const currentWidgets = ref([])

  const currentDate = new Date()
  widgets.forEach((widget) => {
    const startDate = new Date(widget.startDate)
    const endDate = new Date(widget.endDate)
    if (startDate <= currentDate && endDate > currentDate) {
      currentWidgets.value.push(widget)
    }

    if (startDate > currentDate) {
      setTimeout(() => {
        currentWidgets.value.push(widget)
      }, startDate - currentDate)
    }

    if (endDate > currentDate && startDate <= currentDate) {
      setTimeout(() => {
        currentWidgets.value = currentWidgets.value.filter((currentWidget) => currentWidget.id !== widget.id)
      }, endDate - currentDate)
    }
  })

  return currentWidgets
}
